import * as _ from 'lodash';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nameFilter',
})
export class namePipe implements PipeTransform {
  transform(array: any[], query: string): any {
    if (query) {
      return _.filter(array, (row) => 
        (
          row.id?.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
          row.nameEn?.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
          row.customerName?.toLowerCase().indexOf(query.toLowerCase()) > -1 || 
          row.customerMobile?.toLowerCase().indexOf(query.toLowerCase().replaceAll(" ","") ) > -1 || 
          (row.customerCountryCode?.toLowerCase() + row.customerMobile?.toLowerCase()).indexOf(query.toLowerCase().replaceAll(" ","")) > -1 || 
          ('+' + row.customerCountryCode?.toLowerCase() + row.customerMobile?.toLowerCase()).indexOf(query.toLowerCase().replaceAll(" ","")) > -1 || 
          row.membershipType?.toLowerCase().indexOf(query.toLowerCase()) > -1
          )
      );
    }
    return array;
  }
}


